import React, { FC, lazy, Suspense, useEffect, useState } from "react";
import SecondaryTitle from "../text/SecondaryTitle";
import MainText from "../text/MainText";
import MainButton from "../buttons/MainButton";
import { Product } from "../../models/Product";
import { useCart } from "../../context/CartContext";
import NumberFormat from "../text/NumberFormat";

type Props = {
  title?: string;
  protitle?: string;
  image?: string;
  slug?: string;
  description?: string;
  logo?: string;
  className?: string;
  bgColor?: string;
  colClass?: string;
  btnText?: string;
  btnLogo?: string;
  btnFullWidth?: string;
  imageClass?: string;
  titleClass?: string;
  price?: string;
  textLink?: string;
  shadow?: boolean;
  product?: Product;
  projectName?: string;
  alt_key?: string;
  is_subscribed?: boolean;
  id?: number;
  disabled?: boolean;
  onSelect?: (id: number, isChecked: boolean) => void;
  isChecked?: boolean;
};

// Lazy load ProductNumber modal
const LazyProductNumber = lazy(() => import("../modals/ProductNumber"));

const CardLayoutOne: FC<Props> = ({
  colClass,
  shadow,
  price,
  textLink,
  bgColor,
  titleClass,
  title,
  protitle,
  imageClass,
  image,
  slug,
  description,
  logo,
  className,
  btnText,
  btnLogo,
  btnFullWidth,
  product,
  projectName,
  is_subscribed,
  id,
  alt_key,
  disabled,
  onSelect,
  isChecked,
}) => {
  const [numberModalIsOpen, setNumberModalIsOpen] = useState(false);
  const [isCheckedState, setIsCheckedState] = useState(isChecked);
  useEffect(() => {
    setIsCheckedState(isChecked); // Keep state in sync with parent component
  }, [isChecked]);

  const handleToggleSelection = () => {
    const newCheckedState = !isCheckedState; // Toggle checked/unchecked
    setIsCheckedState(newCheckedState);
    onSelect!(id!, newCheckedState); // Pass selection to parent
  };
  const {
    addToCart,
    toCartItem,
    disableAddToCart,
    disableGiftNow,
    setDisableAddToCart,
    setDisableGiftNow,
  } = useCart();
  const [isGift, setIsGift] = useState<any>();

  const openNumberModal = () => {
    setNumberModalIsOpen(true);
    setIsGift(false);
  };

  const closeNumberModal = () => {
    setNumberModalIsOpen(false);
  };

  return (
    <div className={`${colClass} pt-2 pb-2 ${className}`}>
      <div
        className={`card-layout ${bgColor} card card-custom card-stretch gutter-b`}
      >
        <div className="card-body d-flex flex-column">
          <div className="flex-grow-1 pb-3">
            <div className={"text-center"}>
              <img
                src={image}
                className={`w-100 ${imageClass} bdr-15`}
                alt={alt_key}
              />
              {shadow && (
                <img
                  src={"/assets/images/home/shadow.png"}
                  className={"w-50"}
                  alt={""}
                />
              )}
            </div>

            <div className={"mt-4"}>
              {/* <SecondaryTitle
                className={`primary-title ${titleClass}`}
                text={title}
              /> */}
              <h3 className={`primary-title ${titleClass}`}>{title}</h3>
              <h2 className={`primary-title ${titleClass}`}>{protitle}</h2>
            </div>
            {projectName && (
              <div className={"main-p f-title-bold letter-spacing"}>
                {projectName}
              </div>
            )}
            {logo && (
              <div className={"text-center"}>
                <img src={logo} className={"w-50"} alt={"logo"} />
              </div>
            )}

            <MainText
              className={"main-p text-color mt-4 mb-4 "}
              text={description}
            />
          </div>
          <div className="align-items-center text-center pb-4">
            {price && (
              <div className={"text-light-green mt-2"}>
                USD {<NumberFormat value={price} />}
              </div>
            )}

            {product && product.is_numbered === 0 ? (
              <MainButton
                className={`btn btn-primary-dark ps-lg-4 pe-lg-4 ps-3 pe-3 ${btnFullWidth}`}
                text={btnText}
                withLogo={true}
                btnLogo={btnLogo}
                onClick={() =>
                  product
                    ? addToCart({ ...toCartItem(product), is_cart: true })
                    : null
                }
                disabled={disableGiftNow}
              />
            ) : product && product.is_numbered === 1 ? (
              <>
                <MainButton
                  onClick={openNumberModal}
                  className={`btn btn-primary-dark ps-lg-4 pe-lg-4 ps-3 pe-3 ${btnFullWidth}`}
                  text={btnText}
                  withLogo={true}
                  btnLogo={btnLogo}
                  disabled={disableGiftNow}
                />
                <Suspense fallback={<></>}>
                  <LazyProductNumber
                    isOpen={numberModalIsOpen}
                    onClose={closeNumberModal}
                    product={product}
                    isGift={isGift}
                  />
                </Suspense>
              </>
            ) : is_subscribed ? (
              <>
                <button
                  className="btn btn-primary-dark checkbox-btn"
                  disabled={disabled}
                  onClick={handleToggleSelection}
                >
                  <input
                    type="checkbox"
                    id={`select${id}`}
                    className="custom-checkbox"
                    onChange={handleToggleSelection}
                    checked={isCheckedState}
                  />
                  <span>Select</span>
                </button>
              </>
            ) : (
              <MainButton
                href={`${slug}`}
                className={`btn btn-primary-dark ps-lg-4 pe-lg-4 ps-3 pe-3 ${btnFullWidth}`}
                text={btnText}
                withLogo={true}
                btnLogo={btnLogo}
              />
            )}

            {textLink && (
              <div>
                <MainButton
                  href={`${slug}`}
                  className={"btn btn-link-dark f-secondary-bold w-75 fs-18"}
                  text={textLink}
                  withLogo={false}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardLayoutOne;

//
